import Content from 'components/common/Content-v2';
import MainTitle from 'components/common/Title';
import LinkButton from 'components/common/LinkButton';
import AddQuoteForm from 'components/forms/quotes/add';
import { useIntl } from 'react-intl';
const AddMember = props => {
	const { formatMessage } = useIntl();
	return (
		<>
			<MainTitle>
				<h1>{formatMessage({ id: 'dashboard.addQuote' })}</h1>
				<LinkButton to="/admin/quotes"> {formatMessage({ id: 'commons.back' })} </LinkButton>
			</MainTitle>
			<Content>
				<AddQuoteForm />
			</Content>
		</>
	);
};
export default AddMember;
